import React, { useState } from 'react';
import '../styles/Login.css';
import axios from 'axios';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setMessage('');

        try {
            await axios.post(`${process.env.NODE_ENV === "development" ? "http://localhost:8000" : "https://lms.appy.pk"}/api/forgot-password`, { email });
            setMessage('Password reset link sent to your email!');
            setEmail('');
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to send reset link. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="auth-page">
            {/* Floating Shapes */}
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>

            <div className="auth-card">
                <div className="icon-container">
                    <img src="/logo.svg" alt="LMS Logo" className="logo-img" />
                </div>

                <div className="auth-header text-center mb-4">
                    <h3>Forgot Password?</h3>
                    <p className="text-muted">Enter your email to reset your password</p>
                </div>

                {message && <div className="alert alert-success py-2 px-3 small text-center fw-medium border-0 bg-success-subtle text-success">{message}</div>}
                {error && <div className="alert alert-danger py-2 px-3 small text-center fw-medium border-0">{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="mb-4 text-start">
                        <label className="form-label fw-bold text-muted small">Email Address</label>
                        <div className="input-group">
                            <span className="input-group-text"><i className="bi bi-envelope"></i></span>
                            <input
                                type="email"
                                className="form-control"
                                placeholder="admin@school.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    <button type="submit" className="btn btn-auth" disabled={loading}>
                        {loading ? (
                            <span><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> Sending...</span>
                        ) : (
                            'Send Reset Link'
                        )}
                    </button>
                </form>

                <div className="mt-4 text-center">
                    <small className="text-muted">Remember your password? <a href="/login" className="text-primary fw-bold hover-underline">Login</a></small>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
